module.exports = __webpack_public_path__ + "img/ic_file-check.b343b2d0.svg";